import { Component, Input, Injector, ViewChild, EventEmitter, Output, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SectionState } from '../../../../shared/components/section/section.model';
import { UrgenceRequete } from '../../../../entities/urgence-requete';
import { BaseControlValueAccessor } from '../../../../shared/core/base-control-value-accessor';
import { DepotRequeteState } from '../../../depot-requete-state.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'jhi-urgence-requete-section',
    templateUrl: './urgence-requete-section.component.html',
    styleUrls: ['./urgence-requete-section.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: UrgenceRequeteSectionComponent,
            multi: true
        }
    ]
})
export class UrgenceRequeteSectionComponent extends BaseControlValueAccessor implements OnInit {
    @Input()
    depotRequeteState: DepotRequeteState;

    @Input()
    urgenceRequeteChampsObligatoireFilled: any;

    @Input()
    showErrorMessageUrgenceRequete: boolean;

    public filteredUrgencesRequete: Array<UrgenceRequete>;

    @ViewChild('notificationModal') notificationModal: any;

    @Output() onConcernCSDALOChange = new EventEmitter<any>();

    @Output() onUrgenceRequeteChangeEvt = new EventEmitter<any>();

    modalReference: any;

    state: SectionState = { index: 1};

    stateDalo: SectionState = {index: 2, isToggleable: false}

    urgenceRequete: UrgenceRequete;

    urgenceRequeteId: string;

    urgenceRequeteFaqCategoryId = '20';

    constructor(injector: Injector,
        private modalService: NgbModal) {
        super(injector);
    }

    ngOnInit(): void {
       this.filteredUrgencesRequete =
       this.depotRequeteState.typeJuridiction.urgencesRequete.filter(u => !u.isDeleted);
    }

    registerOnChange(fn: any): void {
        super.registerOnChange(fn);
    }


    protected modelValueChanged(value: UrgenceRequete | boolean): void {
        if (typeof value !== 'boolean') {
            this.urgenceRequeteId = value && value.id.toString();
            this.urgenceRequete = value;
        }
    }

    onUrgenceRequeteChange(urgenceRequeteId: string) {
        this.onChange(this.urgenceRequete = this.depotRequeteState.typeJuridiction.urgencesRequete.find(urgenceRequete =>
            urgenceRequete.id === +urgenceRequeteId));
        console.log('onUrgenceRequeteChange | this.urgenceRequete : ', this.urgenceRequete);
        this.onUrgenceRequeteChangeEvt.emit(this.urgenceRequete);
    }

    onConcernCSChange(value: any) {
        /* this.onChange(this.depotRequeteState.concernContentieuxSocial = value);
        console.log('onConcerneCSChange', this.depotRequeteState.concernContentieuxSocial); */
        this.onConcernCSDALOChange.emit(value);
    }

    openWarningModal(modal) {
        this.modalReference = this.modalService.open(modal, { size: 'lg'});
        this.modalReference.result.then((_) => {
            this.modalReference.close();
        },
        _ => {
            this.modalReference.close();
        });
            // RGAA workaround
        const modalEl = document.querySelector('ngb-modal-window');
        modalEl.setAttribute('aria-label', 'Avertissement');
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/requete/urgence-requete-section/urgence-requete-section.component.ts